import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const storeProviderBenefitsStability = createAsyncThunk(
    "bot/providerBenefitsStability",
    async ({ token, form }, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/benefits-intake`,
                form,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
        }
    }
);

const providerBenefitsStabillity = createSlice({
    name: "providerBenefitsStabillity",
    initialState: {
        providerBenefitsStabilityData: [],
    },
    extraReducers: (builder) => {
        builder
            .addCase(storeProviderBenefitsStability.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(storeProviderBenefitsStability.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message;
            })
            .addCase(storeProviderBenefitsStability.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })
    },
});

export default providerBenefitsStabillity.reducer;
